import * as React from "react";
import { NextCMSFooter } from "./NextCMSFooter";
import { connectWithDefaultStores } from "../stores/stores";

type PageFooterProps = {
	hasCountrySiteCoreURL: boolean;
	isReduced: boolean;
	isNoFooter: boolean;
};

export const DisconnectedPageFooter = ({ hasCountrySiteCoreURL, isReduced, isNoFooter }: PageFooterProps) => {
	if (hasCountrySiteCoreURL) {
		return <NextCMSFooter isReduced={isReduced} location={window.location} isNoFooter={isNoFooter} />;
	}

	return null;
};

const wrapped = connectWithDefaultStores(
	{
		stores: {
			FooterStore: (s: any) => ({
				isReduced: s.getIsReducedFooter(),
				isNoFooter: s.getIsNoFooter(),
			}),
		},
	},
	DisconnectedPageFooter,
) as React.ComponentType<Omit<PageFooterProps, "isReduced" | "isNoFooter">>;
export default wrapped;
